<template>
  <section id="about" class="about">
    <div class="container">
      <h2 class="section-title">关于我们</h2>
      <div class="about-content">
        <div class="about-text">
          <p>
            宿迁瀚得教育科技有限公司是一家国内领先的智慧图书馆整体解决方案服务商，从事智慧图书馆平台软件研发、硬件生产、销售一体的高新技术企业，公司拥有多项产品软著、检测报告、专利等证书。面向全国中小学图书馆、大专院校图书馆、公共图书馆、企事业单位职工书屋、24小时城市书房等提供专业的智慧图书馆建设解决方案;目前已服务过客户超1000家落地成功案例。
          </p>
          <p>
            公司拥有一支经验丰富的软硬件研发团队，多年来产品经过不断调整、优化产品结构和技术体系，软硬件产品操作流畅、稳定，打造出一整套以RFID技术为核心腾馨慧图书馆产品;图书馆管理平台及自助借还终端等产品可以提供标准的SIP2协议及接口，可对接智慧校园平台、校园一卡通平台等。
          </p>
          <p>
            本公司新建图书库房1000余平，主要从事大、中、小学图书馆及社会图书馆、农家书屋、企事业机关单位、社区图书馆、幼儿园等图书馆配书业务，以及涵盖智慧化图书馆建设整体解决方案、图书数据加工的业务。
          </p>
        </div>
        


        <div class="stats">
          <div class="stat-item">
            <div class="stat-number">20+</div>
            <div class="stat-label">年行业沉淀</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">1000+</div>
            <div class="stat-label">项目落地</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">全国</div>
            <div class="stat-label">销售与服务体系</div>
          </div>
          <div class="stat-item">
            <div class="stat-number">7×24</div>
            <div class="stat-label">运维响应支持</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AboutSection'
}
</script>

<style scoped>
.about {
  padding: 100px 0;
  background: #fff;
}

.section-title {
  text-align: center;
  font-size: 42px;
  margin-bottom: 48px;
  color: #0c4a6e;
  font-weight: 700;
}

.about-content {
  max-width: 1000px;
  margin: 0 auto;
}

.about-text {
  text-align: center;
  margin-bottom: 56px;
}

.about-text p {
  font-size: 17px;
  line-height: 1.85;
  color: #475569;
  margin: 0;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  text-indent: 2em;
}

.stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 36px;
  padding-top: 40px;
  border-top: 1px solid #e2e8f0;
}

.stat-item {
  text-align: center;
}

.stat-number {
  font-size: 48px;
  font-weight: 700;
  color: #0284c7;
  margin-bottom: 8px;
}

.stat-label {
  font-size: 15px;
  color: #64748b;
  font-weight: 500;
}
</style>
